export const employeePermissions = {
    List: 2000,
    Create: 2001,
    Update: 2002,
    ShowDetails: 2003,
    Delete: 2004,
    LockUnLock: 2005,
    Print: 2006,
    EmployeeReturn: 2007,
    // Reuse the existing user-management permission for password resets.
    ResetPassword: 9006,
}

export const employeeCoursesPermissions = {
    List: 5000,
    Create: 5001,
    Update: 5002,
    ShowDetails: 5003,
    Delete: 5004,
}

export const employeeQualificationsPermissions = {
    List: 4000,
    Create: 4001,
    Update: 4002,
    ShowDetails: 4003,
    Delete: 4004,
}

export const employeeHealthPermissions = {
    List: 3000,
    Create: 3001,
    Update: 3002,
    ShowDetails: 3003,
    Delete: 3004,
}